import React from "react";
import { useTranslation } from "react-i18next";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
      <div className="flex flex-col mt-28 mb-8 py-6 px-4 sm:px-8 max-w-4xl mx-auto bg-white dark:bg-neutral-900/40 shadow-sm border border-gray-100 dark:border-white/5 rounded-2xl max-h-[85vh]">
        {/* Header Section */}
        <div className="flex flex-col items-center text-center gap-3 pt-4 pb-6 shrink-0">
          <div className="p-3 bg-blue-50 dark:bg-blue-500/10 rounded-xl text-blue-500 dark:text-dark-primary">
            <ShieldOutlinedIcon className="w-7 h-7" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
            {t("privacy.title")}
          </h1>
          <div className="w-12 h-1 bg-blue-500 dark:bg-dark-primary rounded-full mt-1" />
        </div>

        {/* Content Area with Overflow Scroll */}
        <div className="flex-1 overflow-y-auto pr-2 space-y-6 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray-200 dark:scrollbar-thumb-neutral-800 text-gray-600 dark:text-gray-300 text-sm leading-relaxed mb-4">
          <section className="p-5 bg-gray-50/50 dark:bg-neutral-800/20 border border-gray-100 dark:border-white/5 rounded-xl">
            <h2 className="text-base font-bold text-gray-900 dark:text-white mb-2 uppercase tracking-wide">
              {t("privacy.section1_title")}
            </h2>
            <p>{t("privacy.intro")}</p>
          </section>

          <section className="p-5 bg-gray-50/50 dark:bg-neutral-800/20 border border-gray-100 dark:border-white/5 rounded-xl">
            <h2 className="text-base font-bold text-gray-900 dark:text-white mb-2 uppercase tracking-wide">
              {t("privacy.section2_title")}
            </h2>
            <p>{t("privacy.responsible")}</p>
          </section>

          <section className="p-5 bg-gray-50/50 dark:bg-neutral-800/20 border border-gray-100 dark:border-white/5 rounded-xl">
            <h2 className="text-base font-bold text-gray-900 dark:text-white mb-2 uppercase tracking-wide">
              {t("privacy.section3_title")}
            </h2>
            <p>{t("privacy.data_collection")}</p>
          </section>

          <section className="p-5 bg-gray-50/50 dark:bg-neutral-800/20 border border-gray-100 dark:border-white/5 rounded-xl">
            <h2 className="text-base font-bold text-gray-900 dark:text-white mb-2 uppercase tracking-wide">
              {t("privacy.section4_title")}
            </h2>
            <p>{t("privacy.cookies")}</p>
          </section>

          <section className="p-5 bg-gray-50/50 dark:bg-neutral-800/20 border border-gray-100 dark:border-white/5 rounded-xl">
            <h2 className="text-base font-bold text-gray-900 dark:text-white mb-2 uppercase tracking-wide">
              {t("privacy.section5_title")}
            </h2>
            <p>{t("privacy.rights")}</p>
          </section>
        </div>
      </div>
  );
};

export default PrivacyPolicy;